"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "apiSaga", {
  enumerable: true,
  get: function () {
    return _saga.apiSaga;
  }
});
exports.getAPIFn = exports.defaultCount = void 0;
exports.initializeAPIStore = initializeAPIStore;
var _saga = require("./store/api/saga");
// Helpers
let getAPIFn = exports.getAPIFn = void 0;
let defaultCount = exports.defaultCount = void 0;
function initializeAPIStore(options) {
  const {
    getAPI,
    clockCount
  } = options;
  if (!getAPI) throw new Error("The getAPI function is required to use the package");
  exports.getAPIFn = getAPIFn = getAPI;
  exports.defaultCount = defaultCount = clockCount || 10;
}